// Russian translations for src/config/notes.md.
//
// Keys are note IDs (slugified from the English ## heading — same algorithm as
// in src/ui/notes.ts parseNotes()). Each entry may provide `title` and/or
// `body`; missing fields fall back to English. Translations are filled in
// incrementally — untranslated notes simply show the English source.
import type { ContentBlock } from './index'

export const notesRu: Record<string, ContentBlock> = {
  block: {
    title: 'Блок',
    body: `**Блок** — защитная механика, открываемая **первой Трансценденцией** (проверка выполняется постоянно — любое сохранение с одной или более Трансценденциями её имеет). Когда вы получаете **удар**, у вас есть **базовый шанс 5 %** заблокировать **20 %** урона этого удара. После блока блок **восстанавливается 1 секунду**, прежде чем сможет сработать снова (база: один блок в секунду).

Правила:

- Блок действует только на **удары** — тики недугов (горение, кровотечение, яд) никогда не могут быть заблокированы.
- Заблокированный удар всё равно даёт **полный опыт жизни** — блок никогда не уменьшает опыт жизни.
- Заблокированный удар всё ещё может наложить недуги, и их урон основан на **полном уроне удара до блока**. Главный узел «Эффективность блока» может полностью подавить недуги от заблокированных ударов.
- Бонусы **скорости восстановления блока** добавляют целые блоки в секунду: +100 % = 2 блока в секунду. Полное мастерство Блока (8 узлов восстановления) достигает **9 блоков в секунду**.

Блокирование даёт опыт **мастерства Блока** в зависимости от количества предотвращённого урона, с теми же требованиями и множителями, что и мастерство Жизни (поначалу медленно — низкий шанс блока означает мало предотвращённого урона).`,
  },
}
